import { Module } from 'vuex';
import { Exception } from '@/modules/shared/shared/domain/exceptions/exception';
import { TutorialFile } from '@/modules/infodayco/shared/domain/tutorial-file';
import { ServiceModelsState } from '@/modules/infodayco/service-model/store/service-models.state';
import { ServiceModelsGetters } from '@/modules/infodayco/service-model/store/service-models.getters';
import { ServiceModelsMutations } from '@/modules/infodayco/service-model/store/service-models.mutations';
import { GuideView } from '@/modules/infodayco/shared/domain/guide.view';
import { ServiceModelsActions } from '@/modules/infodayco/service-model/store/service-models.actions';
import serviceModelRepository from '@/modules/infodayco/shared/repositories/service-model.repository';
import { fromBuffer } from 'file-type';

const serviceModels: Module<ServiceModelsState, any> = {
    namespaced: true,
    state: {
        view: {
            guides: [],
        },
    },
    getters: {
        [ServiceModelsGetters.GET_VIEW](state): GuideView {
            return state.view;
        },
    },
    mutations: {
        [ServiceModelsMutations.SET_VIEW](state, view: GuideView) {
            state.view = view;
        },
    },
    actions: {
        async [ServiceModelsActions.FETCH_VIEW]({ commit }) {
            try {
                const view = await serviceModelRepository.getAll();
                commit(ServiceModelsMutations.SET_VIEW, view);
            } catch (e) {
                return new Exception(e.response);
            }
        },
        async [ServiceModelsActions.DOWNLOAD_SERVICE_MODEL]({}, tutorial: TutorialFile) {
            try {
                const data = await serviceModelRepository.getServiceModels(tutorial);
                const result = await fromBuffer(data.data);
                const file = new Blob([data.data], {
                    type: result ? result.mime : 'application/pdf',
                });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                return false;
            } catch (e) {
                return new Exception(e.response);
            }
        },
        async [ServiceModelsActions.DELETE_SERVICE_MODEL]({ dispatch }, tutorial: TutorialFile) {
            try {
                await serviceModelRepository.deleteServiceModel(tutorial);
                return await dispatch(ServiceModelsActions.FETCH_VIEW);
            } catch (e) {
                return new Exception(e.response);
            }
        },
    },
};

export default serviceModels;
